import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayerQcService } from 'app/services/layer-qc.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
import { Subscription } from 'rxjs';
import * as showdown from 'showdown';

interface TooltipDetail {
	code: string;
	html: string;
	fieldsHtml?: string;
}

@Component({
  selector: 'app-tooltip-help',
  templateUrl: './tooltip-help.component.html',
  styleUrls: ['./tooltip-help.component.css']
})
export class TooltipHelpComponent implements OnInit, OnDestroy {

	tooltips: TooltipDetail[];
	selectedTooltip: TooltipDetail;

	lastTooltipSub: Subscription;
	constructor(
		private qcService: LayerQcService,
		private tooltipHelpService: TooltipHelpService
	) { }

	onClickCode(tooltip: TooltipDetail) {
		this.selectTooltip(tooltip);
	}
	private selectTooltip(tooltip: TooltipDetail) {
		this.selectedTooltip = tooltip;
	}
	ngOnInit() {
		this.lastTooltipSub = this.tooltipHelpService.lastTooltipsBS.subscribe(data => {
			this.tooltips = [];
			if (data && data.codes) {
				data.codes.forEach(cd => {
					const detail = this.qcService.qaRuleDetails.find(i => i.code === cd);
					if (detail) {
						const causeFix = detail.causeFix.replace('<image>', `<img src="https://www.linearbench.com/GIV_Photo/${cd}.png">`);
						const converter = new showdown.Converter();
						const htmlCauseFix = converter.makeHtml(causeFix);
						const htmlException = detail.exception ? converter.makeHtml(detail.exception) : '';
						const tooltip: TooltipDetail = {
							code: cd,
							html: htmlCauseFix + '\n' + htmlException
						};
						if (detail.fields) {
							tooltip.fieldsHtml = converter.makeHtml(detail.fields);
						}
						this.tooltips.push(tooltip);
					}
				});
			}
			this.selectTooltip(this.tooltips[0]);
		});
	}
	ngOnDestroy(): void {
	}

}
